import { useDemoMode } from "@/contexts/DemoModeContext";

const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN as string | undefined;

export function PaymentTestModeBanner() {
  // Hide the banner while Demo Mode is active so admins can capture
  // clean screenshots / videos without the orange test-mode strip.
  const { isDemo } = useDemoMode();
  if (isDemo) return null;

  if (!clientToken) {
    return (
      <div className="w-full bg-destructive/10 border-b border-destructive/30 px-4 py-2 text-center text-sm text-destructive">
        Production checkout is not configured yet. Complete payments go-live in your project to accept real payments.
      </div>
    );
  }
  if (clientToken.startsWith("pk_test_")) {
    return (
      <div className="w-full bg-orange-100 border-b border-orange-300 px-4 py-2 text-center text-sm text-orange-800">
        Test mode — payments made here are not real charges.
      </div>
    );
  }
  return null;
}